export const maxWidgetReadyTime: number = 8000;
export const initErrorMessage: string = `We are experiencing some technical difficulties, and can't accept your payment right now. Please try again in a little while.`;
